import { defineComponent as _defineComponent } from 'vue'
import {CanadaFOPHighInMetadata} from "@/models/NutritionLabels/CanadaFOPHighInMetadata";
import {LabelRenderDto} from "@/models/NutritionLabels/v2/RenderLabelDto";
import {NutritionLabelDownloadFileFormat} from "@/models/NutritionLabels/NutritionLabelDownloadFileFormat";
import {ExportLabelState2} from "@/models/NutritionLabels/v2/ExportLabelState2";
import CanadaFrontOfPackConfiguration from "@/components/labelConfiguration/FoP/CanadaFrontOfPackConfiguration.vue";
import UkFrontOfPackageConfiguration from "@/components/labelConfiguration/FoP/UkFrontOfPackConfiguration.vue";
import {computed, inject, ref} from "vue";
import {ExportLabelView} from "@/models/Cautionary/ExportLabelView";

type FrontOFPackageConfigProps = {
  value: ExportLabelState2;
  recipeId: number;
  highIn: CanadaFOPHighInMetadata;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vFrontOfPackageConfig',
  props: {
    value: null,
    recipeId: null,
    highIn: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  value: ExportLabelState2;
  recipeId: number;
  highIn: CanadaFOPHighInMetadata;
};


const fetchPreviewV2: (renderData: LabelRenderDto, requestingScreen: ExportLabelView) => Blob = inject("fetchPreview");

const canadaFopConfigComponent = ref();
const ukFopConfigComponent = ref();
const renderModel = computed(() => {
  if (props.value.nutritionCountry.name == 'Canada') {
    return canadaFopConfigComponent.value.renderModel;
  }

  else if (props.value.nutritionCountry.name == 'UK') {
    return ukFopConfigComponent.value.renderModel;
  }

  else {
    return null;
  }
});

function fetchPreview() {
  fetchPreviewV2(
    {
      format: NutritionLabelDownloadFileFormat.jpeg,
      ...renderModel.value
    },
    ExportLabelView.FOP
  );
}

function enter() {
  if (props.value.nutritionCountry.name == 'Canada') {
    canadaFopConfigComponent.value.loadLabelFormats();
  }
}

expose({ renderModel, fetchPreview, enter });

return { __sfc: true,props, fetchPreviewV2, canadaFopConfigComponent, ukFopConfigComponent, renderModel, fetchPreview, enter, CanadaFrontOfPackConfiguration, UkFrontOfPackageConfiguration }
}

})